import InternalCheckbox from './Checkbox';
import Group from './Group';
export { CheckboxChangeEvent, CheckboxProps } from './Checkbox';
export { CheckboxGroupProps, CheckboxOptionType } from './Group';
const Checkbox = InternalCheckbox;
Checkbox.Group = Group;
Checkbox.__BWD_CHECKBOX = true;
export default Checkbox;
